export default {
  title: 'Audience test',
  columns: {
    id: 'Id',
    phone_number: 'Numéro de téléphone',
  },
  filters: {
    search: {
      placeholder: 'Rechercher',
    },
  },
  buttons: {
    send_test: 'Envoyer un test',
  },
  feedback: {
    success: 'Envoyé avec succès',
    error: "Échec de l'envoi",
  },
};
